// The asset a measurement point role belongs to, in the order the installation pages list them.
export const ROLE_GROUP_ICONS: Readonly<Record<string, string>> = {
  grid: 'bolt',
  pv: 'solar_power',
  battery: 'battery_charging_full',
  ev: 'ev_station',
  heatpump: 'heat_pump',
  household: 'home',
  submeter: 'electric_meter',
  other: 'sensors',
};

const ROLE_GROUP_PREFIXES: readonly (readonly [string, string])[] = [
  ['grid_', 'grid'],
  ['net_grid_', 'grid'],
  ['active_power_', 'grid'],
  ['voltage_', 'grid'],
  ['current_', 'grid'],
  ['pv_', 'pv'],
  ['battery_', 'battery'],
  ['ev_', 'ev'],
  ['heatpump_', 'heatpump'],
  ['household_', 'household'],
  ['submeter_', 'submeter'],
];

export function roleGroupKey(role: string): string {
  return ROLE_GROUP_PREFIXES.find(([prefix]) => role.startsWith(prefix))?.[1] ?? 'other';
}
